import { render, staticRenderFns } from "./CampRelationForm.vue?vue&type=template&id=65714a44&scoped=true&"
import script from "./CampRelationForm.vue?vue&type=script&lang=js&"
export * from "./CampRelationForm.vue?vue&type=script&lang=js&"
import style0 from "./CampRelationForm.vue?vue&type=style&index=0&id=65714a44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65714a44",
  null
  
)

export default component.exports